var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63237 3.26019L6.29682 2.50521C6.07742 2.01157 5.96772 1.76473 5.80366 1.57584C5.59805 1.33912 5.33004 1.16495 5.03022 1.07321C4.79098 1 4.52087 1 3.98066 1C3.19041 1 2.79529 1 2.46359 1.15191C2.07288 1.33085 1.72002 1.7194 1.57943 2.1255C1.46008 2.47024 1.49427 2.82453 1.56264 3.53308C2.29041 11.0752 6.42534 15.2101 13.9674 15.9378C14.676 16.0062 15.0303 16.0404 15.375 15.9211C15.7811 15.7805 16.1696 15.4276 16.3486 15.0369C16.5005 14.7052 16.5005 14.3101 16.5005 13.5198C16.5005 12.9796 16.5005 12.7095 16.4273 12.4702C16.3355 12.1704 16.1614 11.9024 15.9246 11.6968C15.7358 11.5327 15.489 11.4231 14.9953 11.2037L14.2403 10.8681C13.7057 10.6305 13.4384 10.5117 13.1668 10.4859C12.9068 10.4612 12.6447 10.4977 12.4014 10.5924C12.1471 10.6914 11.9225 10.8787 11.473 11.2532C11.0256 11.626 10.802 11.8124 10.5286 11.9122C10.2863 12.0007 9.96595 12.0336 9.71079 11.9959C9.42287 11.9535 9.20245 11.8358 8.76154 11.6001C7.38987 10.8671 6.63343 10.1107 5.90038 8.73892C5.66477 8.29808 5.54697 8.07758 5.50454 7.78975C5.46694 7.5345 5.49972 7.21417 5.58824 6.97192C5.68809 6.69857 5.87449 6.47488 6.24731 6.0275C6.62184 5.57807 6.8091 5.35335 6.90811 5.09909C7.00286 4.85578 7.03934 4.59367 7.01461 4.33373C6.98877 4.0621 6.86997 3.7948 6.63237 3.26019Z",
    stroke: "#757575",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImg);
export default __webpack_public_path__ + "static/media/phone-img.177fa4e203bd9b973e7ceb3d896c0f54.svg";
export { ForwardRef as ReactComponent };